import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-cbae14f2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "actor-warp"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "table-warp cms-card-block"
};
import { usePageConfig, useTableOptions } from '@/utils/useComponentConfig';
import { messageBox } from '@/utils/validate';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { getContentPriceListApi, deleteContentPriceListApi } from '@/api/vodNew';
import dayjs from 'dayjs';
import Edit from './edit';
import { ElMessage } from 'element-plus';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const formRef = ref(null);
    const checkDetailDialog = reactive({
      visible: false,
      loading: false
    });
    const editObj = ref({
      visible: false,
      mode: 'add',
      data: null
    });
    const addOrEditScheme = reactive({
      visible: false
    });
    const dialogFormData = ref({});
    const priceData = ref([]);
    const tableConfig = reactive({
      data: [],
      isCardBlock: false,
      loading: false,
      isShowHeader: true,
      listName: t('内容定价'),
      paginationConfig: usePageConfig(),
      options: useTableOptions(),
      columnList: [{
        label: '主品牌',
        prop: 'mainAgentName',
        sortable: 'custom'
      }, {
        label: '子品牌',
        prop: 'subAgentInfos',
        sortable: 'custom',
        formatter: val => val ? val.map(item => item.subAgentName).join(',') : '--'
      }, {
        label: '创建时间',
        prop: 'createTime',
        sortable: 'custom',
        formatter: val => val ? dayjs(val).format('YYYY-MM-DD HH:mm:ss') : '--'
      }, {
        label: '备注',
        prop: 'remark'
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        buttonsList: [{
          label: '编辑',
          func: row => {
            editObj.value.visible = true;
            editObj.value.mode = 'edit';
            let copyData = { ...row
            };
            editObj.value.data = {
              id: copyData.id,
              mainAgentId: copyData.mainAgentId,
              subAgentIds: copyData.subAgentInfos.map(item => item.subAgentId),
              programPrice: copyData.programPrice,
              programValidityDays: copyData.programValidityDays,
              seriesPrice: copyData.seriesPrice,
              seriesValidityDays: copyData.seriesValidityDays,
              remark: copyData.remark
            };
          }
        }, {
          label: '删除',
          func: row => {
            messageBox(t('确定删除这条数据吗?')).then(async () => {
              const {
                code,
                data
              } = await deleteContentPriceListApi(row.id);

              if (code == 0) {
                ElMessage({
                  type: 'success',
                  message: t('删除成功')
                });
                getContentPriceList(1, 10);
              }
            });
          }
        }]
      }],
      headerButtonsList: [{
        label: '新增',
        style: {
          'min-width': '120px'
        },
        func: () => {
          // addOrEditScheme.visible = true
          editObj.value.visible = true;
          editObj.value.mode = 'add';
        }
      }]
    });

    const setOptionsBtnColumnWidth = width => {
      const findItem = tableConfig.columnList.find(item => item.label == '操作');
      findItem.width = width;
    };

    onMounted(() => {
      getContentPriceList(1, 10);
    });

    const onUpdateList = () => {
      getContentPriceList(1, 10);
    }; // 获取列表


    const getContentPriceList = async (pageNo, pageSize, otherParams = {}) => {
      tableConfig.loading = true;
      let params = {
        pageNo,
        pageSize,
        ...otherParams
      };
      const {
        code,
        data
      } = await getContentPriceListApi(params);

      if (code == 0) {
        tableConfig.data = data.records ? data.records : [];
        tableConfig.paginationConfig = {
          limit: data.size,
          total: data.total,
          page: data.current
        };
      }

      tableConfig.loading = false;
    };

    const sizeChange = size => {
      tableConfig.paginationConfig.limit = size;
      getContentPriceList(1, size);
    };

    const currentChange = current => {
      tableConfig.paginationConfig.page = current;
      getContentPriceList(current, tableConfig.paginationConfig.limit);
    };

    return (_ctx, _cache) => {
      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [!addOrEditScheme.visible ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_common_table, {
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref: "tableRef",
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        options: tableConfig.options,
        render: () => {},
        onSizeChange: sizeChange,
        onCurrentChange: currentChange
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": tableConfig.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "options", "render"])])), [[_directive_loading, tableConfig.loading]])])) : _createCommentVNode("", true), _createVNode(_unref(Edit), {
        modelValue: editObj.value.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => editObj.value.visible = $event),
        mode: editObj.value.mode,
        data: editObj.value.data,
        onUpdateList: onUpdateList
      }, null, 8, ["modelValue", "mode", "data"])]);
    };
  }

});